export enum Direction {
  Backwards = -1,
  Forwards = 1,
}

export enum NavType {
  Reset = 0,
  Month,
  Year,
}

export interface CalendarYearMonth {
  month: number;
  year: number;
}

export interface CalendarYearMonthDay extends CalendarYearMonth {
  day: number;
}

export type OnDaySelect = (props: CalendarYearMonthDay) => void;

export type OnMonthYearSettle = (props: CalendarYearMonth) => void;
